<template>
  <header class="overview-header">
    <h2>{{ $t("message.sidebar.message.overview") }}</h2>

    <app-advertising-modal v-if="criarCampanha"></app-advertising-modal>
  </header>
</template>

<script>
import AppAdvertisingModal from "@views/advertising/components/advertising-modal/AdvertisingModal";

export default {
  components: {
    AppAdvertisingModal,
  },
  computed: {
    permissions() {
      return this.$store.state.users.user.permissions;
    },
    criarCampanha() {
      return this.permissions.find((x) => x === "CREATE_CAMPAIGN")
        ? true
        : false;
    },
  },
};
</script>

<style lang="scss" scoped>
.overview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
